import PageLayout from "@/components/layout/PageLayout";
import { translateBrand } from "@/lib/i18n";
import { BrandMessageIds } from "@nitro-ape/shared/lib/brand-config";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_main/trackers")({
  head: () => ({
    meta: [
      {
        title: translateBrand(BrandMessageIds.metaTitleTrackers),
      },
    ],
  }),
  component: TrackersLayout,
});

function TrackersLayout() {
  return (
    <PageLayout>
      <div className="flex h-full w-full flex-col gap-1.5">
        <Outlet />
      </div>
    </PageLayout>
  );
}
